import React from 'react';

const CriticalCSS: React.FC = () => {
  return (
    <style jsx global>{`
      /* Critical CSS for LCP optimization */
      html {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        font-display: swap;
        line-height: 1.6;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
      }
      
      body {
        margin: 0;
        padding: 0;
        background-color: #ffffff;
        color: #1f2937;
        font-size: 16px;
        line-height: 1.6;
      }
      
      /* Critical header styles for LCP */
      header {
        background: white;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        position: sticky;
        top: 0;
        z-index: 50;
      }
      
      /* Critical logo styles */
      .logo-container img {
        display: block;
        max-width: 100%;
        height: auto;
      }
      
      /* Critical hero section styles */
      .hero-section {
        background: linear-gradient(135deg, #334155 0%, #1e293b 50%, #0f172a 100%);
        color: white;
        padding: 3rem 1rem;
        position: relative;
        overflow: hidden;
      }
      
      .hero-section::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.1);
      }
      
      /* Critical text styles */
      h1 {
        font-size: 2.25rem;
        font-weight: 700;
        line-height: 1.2;
        margin: 0 0 1rem 0;
      }
      
      h2 {
        font-size: 1.875rem;
        font-weight: 600;
        line-height: 1.3;
        margin: 0 0 1rem 0;
      }
      
      p {
        margin: 0 0 1rem 0;
        line-height: 1.6;
      }
      
      /* Critical button styles */
      .btn-primary {
        background: #eab308;
        color: #1e293b;
        padding: 0.75rem 1.5rem;
        border-radius: 0.5rem;
        font-weight: 600;
        text-decoration: none;
        display: inline-block;
        transition: background-color 0.2s ease;
      }
      
      .btn-primary:hover {
        background: #ca8a04;
      }
      
      /* Critical layout styles */
      .container {
        max-width: 80rem;
        margin: 0 auto;
        padding: 0 1rem;
      }
      
      .grid {
        display: grid;
        gap: 1.5rem;
      }
      
      /* Critical responsive styles */
      @media (min-width: 640px) {
        h1 {
          font-size: 2.5rem;
        }
        
        .hero-section {
          padding: 4rem 1.5rem;
        }
      }
      
      @media (min-width: 768px) {
        h1 {
          font-size: 3rem;
        }
        
        .hero-section {
          padding: 5rem 2rem;
        }
      }
      
      @media (min-width: 1024px) {
        h1 {
          font-size: 3.75rem;
        }
        
        .hero-section {
          padding: 6rem 2rem;
        }
        
        .grid {
          grid-template-columns: repeat(2, 1fr);
        }
      }
      
      /* Critical image optimization */
      img {
        max-width: 100%;
        height: auto;
        display: block;
      }
      
      /* Critical link styles */
      a {
        color: inherit;
        text-decoration: none;
      }
      
      a:hover {
        text-decoration: underline;
      }
      
      /* Critical phone number styles */
      .phone-number {
        font-size: 1.5rem;
        font-weight: 700;
        color: #eab308;
      }
      
      .phone-number:hover {
        color: #ca8a04;
      }
      
      /* Critical loading states */
      .loading {
        opacity: 0.7;
        transition: opacity 0.3s ease;
      }
      
      .loaded {
        opacity: 1;
      }
    `}</style>
  );
};

export default CriticalCSS; 